module.exports = __webpack_public_path__ + "media/images/discover/logos/logo-white-1line-ab4c4def9f5de739822bfd1bec88804b.svg";